import React from 'react';
import { Layout } from '../components/layout';
import { useSEO } from '../hooks/useSEO';

export const AmazonDisclosure: React.FC = () => {
  useSEO({
    title: 'Amazon Affiliate Disclosure',
    description: 'Amazon Associates affiliate disclosure for ComponentScale.',
  });

  return (
    <Layout>
      <div className="mx-auto max-w-3xl space-y-8 text-fg">
        <div>
          <h1 className="text-3xl font-semibold tracking-tightest text-fg">Amazon Affiliate Disclosure</h1>
          <p className="mt-2 text-sm text-muted">Last updated: February 2026</p>
        </div>

        <div className="rounded-lg border border-accent/40 bg-accent-soft p-4 text-sm text-accent-ink">
          ComponentScale is a participant in the Amazon Services LLC Associates Program.
        </div>

        <section className="space-y-3 text-sm leading-relaxed">
          <p>
            ComponentScale participates in the Amazon Services LLC Associates Program, an affiliate
            advertising program designed to provide a means for sites to earn advertising fees by
            advertising and linking to Amazon.com and affiliated Amazon websites.
          </p>
          <p>
            When you click on an Amazon product link on our site and make a qualifying purchase,
            we may earn a small commission at no additional cost to you. These commissions help
            support the maintenance and development of ComponentScale.
          </p>
          <p>
            We only link to products that are directly relevant to the PC cases listed on this site.
            Our product recommendations and database entries are not influenced by affiliate
            relationships — cases are included based on their specifications and relevance to our
            users, not on whether affiliate links are available.
          </p>
          <p>
            Affiliate links are visually identified by the{' '}
            <span className="font-medium text-fg">retailer name ↗</span>{' '}
            links shown on case cards, detail pages and in the comparison table.
          </p>
          <p>
            As an Amazon Associate, we earn from qualifying purchases. Amazon, the Amazon logo, and
            the Amazon Associates Program are trademarks of Amazon.com, Inc. or its affiliates.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold text-fg">Other Retailers</h2>
          <p className="text-sm leading-relaxed">
            We may also link to other retailers (Newegg, B&H, Micro Center, etc.). These links may
            or may not be affiliate links. Where affiliate relationships exist with non-Amazon
            retailers, the same principles apply: we earn a small commission on qualifying purchases
            at no additional cost to you.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold text-fg">Questions</h2>
          <p className="text-sm leading-relaxed">
            If you have any questions about our affiliate relationships, please visit our{' '}
            <a href="/privacy-policy" className="text-accent-ink hover:underline">
              Privacy Policy
            </a>{' '}
            or open an issue on GitHub.
          </p>
        </section>
      </div>
    </Layout>
  );
};
